import React, {Component} from 'react';
import {Button, Col, Icon, Modal, Popconfirm, Popover, Row, Spin, Table} from "antd";
import {api, app} from "../../app";
import utils from "../../utils";
import config from "../../config";
import PayTemplate from "../../components/PayTemplate";

class MineTrainDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item:[]
        }
    }

    componentDidMount() {
        this._isMounted = true;
        this.particulars()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    //取消培训
    cancel = async (ordersNo) => {
        let { page } = this.state,
            params = {
                orders_no:ordersNo
            }
        const { flag, msg } = await app.post(api.SkillTrainCancel, params)
        if (flag === 1) {
            app.alert('操作成功', 'success')
            await this.particulars()
            return true
        } else {
            app.alert(msg, 'warn')
            throw false
        }
    }

    //订单支付
    pay = async (ordersNo,type) => {
        let {pay_loading,page} = this.state,
            params = {
                orders_no:ordersNo,
                pay_method:type
            }
        if (pay_loading) return false
        await this.setData({pay_loading: true})
        const { flag, data, msg } = await app.post(api.SkillTrainOrdersZhifu, params)
        app.alertDestroy()
        if (flag === 1) {
            Modal.confirm({
                title: '扫码支付',
                centered: true,
                icon: type==2?(<Icon type="alipay-circle" style={{ color: '#00A1E9' }} />):(<Icon type="wechat" style={{color: '#00D30C'}}/>),
                width: 600,
                content: type==2?(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} />):(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} terminal="微信" />),
                okText: '已支付',
                cancelText: '关闭',
                onOk: async () => {
                    const { flag, msg } = await app.post(api.SkillTrainConfirmPay, {
                        orders_no: data.ordersNo
                    })
                    if (flag === 1) {
                        app.alert('支付成功', 'success')
                        await this.particulars()
                        return true
                    } else {
                        app.alert(msg, 'warn')
                        throw false
                    }
                }
            })
        } else {
            app.alert(msg, 'warn')
        }
        await this.setData({ pay_loading: false })
    }

    /**
     * 详情
     **/
    particulars = async () => {
        await this.setData({ data_loading: true })
        let { orders_no } = this.props, params = {
            orders_no
        }
        let { flag, data, msg } = await app.post(api.SkillTrainParticulars, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ item: data, data_loading: false })
    }

    // 培训状态名
    trainStatusName = (e) => {
        switch (e) {
            case '0':
                return '未开始'
                break;
            case '1':
                return '进行中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    applyName = (e) => {
        switch (e) {
            case '1':
                return '报名中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let { item,data_loading } = this.state
        return(
            <div className="list-data-r">
                {data_loading?(<div className="mall-loading"><Spin size="large"/></div>):
                <div>
                    <Row type="flex" justify="center">
                        <Col className="list-data-c" span={22}>姓名：{item.vname}</Col>
                        <Col className="list-data-c" span={22}>期望开班城市：{item.province_name}/{item.city_name}</Col>
                        <Col className="list-data-c" span={22}>培训课程：{item.train_name}</Col>
                        <Col className="list-data-c" span={22}>培训科目：{item.names}</Col>
                        {item.apply_count > 10 ?
                            (<Col className="list-data-c" span={22}>已报名人数：{item.apply_count}人</Col>)
                        :null}
                        <Col className="list-data-c" span={22}>培训天数：{item.train_day}天</Col>
                        <Col className="list-data-c" span={22}>考评天数：{item.evaluate_day}天</Col>
                        <Col className="list-data-c" span={22}>考评费用：{item.evaluate_money}元</Col>
                        <Col className="list-data-c" span={22}>培训费用：{item.train_money}元</Col>
                        <Col className="list-data-c" span={22}>培训总费用：{item.train_amount}元</Col>
                        <Col className="list-data-c" span={22}>培训状态：{this.trainStatusName(item.train_status)}</Col>
                        <Col className="list-data-c" span={22}>报名状态：{item.apply_status}</Col>
                        {item.have_paid ?
                            (<Col className="list-data-c" span={22}>已支付费用：{item.have_paid}</Col>)
                        :null}
                        {item.pay_money ?
                            (<Col className="list-data-c red" span={22}>待支付：{item.pay_money}</Col>)
                        :null}
                    </Row>
                    <Row style={{marginTop:'20px'}} type="flex" justify="center">
                        {
                            '0'.indexOf(item.pay_status) > -1 ? (
                                <Col style={{marginLeft:'15px'}} span={5}>
                                    <Popconfirm title="确认取消？" onConfirm={() => this.cancel(item.orders_no)} okText="是" cancelText="否">
                                        <Button type="primary" block>取消</Button>
                                    </Popconfirm>
                                </Col>
                            ):null
                        }
                        {/*<Col span={5}><Button type="primary" block>转班</Button></Col>*/}
                        {
                            '04'.indexOf(item.pay_status) > -1 ? (
                                <Col style={{marginLeft:'15px'}} span={5}>
                                    <Popover content={<div><Button onClick={() =>this.pay(item.orders_no,1)} type="primary">微信</Button><Button onClick={() =>this.pay(item.orders_no,2)} type="primary" style={{marginLeft:'10px'}}>支付宝</Button></div>} title="付款方式">
                                        <Button type="primary" block>前往支付</Button>
                                    </Popover>
                                </Col>
                            ) : null
                        }
                    </Row>
                </div>
                }
            </div>
        )
    }
}
export default MineTrainDetails;



// WEBPACK FOOTER //
// ./src/routes/skillTrain/MineTrainDetails.jsx